export const environment = {
  production: true,
  apiPrefix: "/api/"
};
